// extracted by mini-css-extract-plugin
module.exports = {"inputwrapper":"trial_inputwrapper__RGo-0","labelinput":"trial_labelinput__1So1C"};